import { render } from "./ViewTests.vue?vue&type=template&id=f2c14a7c"
import script from "./ViewTests.vue?vue&type=script&lang=js"
export * from "./ViewTests.vue?vue&type=script&lang=js"

import "./ViewTests.vue?vue&type=style&index=0&id=f2c14a7c&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/orders/ViewTests.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f2c14a7c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f2c14a7c', __exports__)) {
    console.log('reload')
    api.reload('f2c14a7c', __exports__)
  }
  
  module.hot.accept("./ViewTests.vue?vue&type=template&id=f2c14a7c", () => {
    console.log('re-render')
    api.rerender('f2c14a7c', render)
  })

}


export default __exports__